import { ShieldAlert } from 'lucide-react'

interface PublicLinkErrorProps {
  title: string
  message: string
}

/** Stato condiviso per link pubblici scaduti, non validi o non più disponibili. */
export function PublicLinkError({ title, message }: PublicLinkErrorProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-page px-4 py-10">
      <section role="alert" className="w-full max-w-md rounded-xl border border-border bg-canvas p-6 text-center shadow-sm sm:p-8">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-danger-50 text-negative">
          <ShieldAlert size={24} aria-hidden="true" />
        </div>
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.14em] text-muted">DomusAurea</p>
        <h1 className="mb-2 text-xl font-semibold text-heading">{title}</h1>
        <p className="m-0 text-sm leading-6 text-muted">{message}</p>
      </section>
    </main>
  )
}
